<div [formGroup]="formGroup">
  <pr-input-autosuggest
    [formControlName]="'country'"
    [label]="label"
    [options]="countries"
    [derrors]="derrors"
    [highlightOnValue]="highlightOnValue"
    [optionLabel]="'value'"
    [noCustom]="true"
    [optionIcon]="getIcon"
    [favorites]="['fr']"
    placeholder=""
  >
  </pr-input-autosuggest>
</div>
